import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Instalacion/imprimirInstalacion`, method: 'POST', body: list, token: token})
}